// Sticky sidebar
var sticky = new Sticky('.faq-anchors > .anchors');

// Accordions
const titles = document.querySelectorAll(".faq-container .title-container");

for (const title of titles) {
  title.addEventListener("click", function() {
    var height = this.offsetHeight;
    this.style.height = height;
    this.classList.toggle('active');
  });
}